import { NestApiType, nestCall } from '@/composables/nestApi';

/* eslint-disable import/prefer-default-export */
export const registerExportRequest = async (
  idsTobeExported: number[],
  idShop: number,
  idUser: number,
  userType: string,
  type: string,
) => nestCall('post', NestApiType.DEFAULT, '/data/export-request', {}, '', {
  idsTobeExported,
  idShop,
  type,
  idUser,
  userType,
});
